import { render } from "./CourseTests.vue?vue&type=template&id=e3933220&scoped=true"
import script from "./CourseTests.vue?vue&type=script&lang=js"
export * from "./CourseTests.vue?vue&type=script&lang=js"

import "./CourseTests.vue?vue&type=style&index=0&id=e3933220&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3933220"]])

export default __exports__